export default {
  data() {
    return {
      message: { attachment_uuids: [], type: 'email' },
      messageCopy: { attachment_uuids: [] },
      submitting: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.sessionStorageDelete('communication');
    next();
  },
};
